import React from 'react'

import AlertIcon from '../../images/alert.svg'
import EmptyIcon from '../../images/empty-icon.svg'

export const Phoner404: React.FC = () => {
  return (
    <div className='onlinepbx__page__not__found'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center onlinepbx__page__not__found__header'>
            <AlertIcon className='onlinepbx__page__not__found__alert' /> Ссылка просрочена
          </h2>
          <div className='onlinepbx__page__not__found__text onlinepbx__page__not__found__text__left'>
            Для получения новой ссылки обратитесь к администратору аккаунта onlinepbx (человеку, который поставил задачу скачать PhonerLite).
            <br />
            <br />
            Регистрировать новый аккаунт не нужно. Ваш аккаунт уже создан.
          </div>
          <div className='onlinepbx__page__not__found__block'>
            <div className='onlinepbx__page__not__found__empty-content'>
              <EmptyIcon className='onlinepbx__page__not__found__icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Phoner404
